module.exports = __webpack_public_path__ + "img/dotcom-seance-logo-1.87be7cb5.svg";